module.exports = __webpack_public_path__ + "img/abstract-shapes-5.18c2632f.svg";